import { Alert, Button, DatePicker, Popconfirm, message } from 'antd';
import { CloseCircleFilled } from '@ant-design/icons';
import { ContextStatus } from '@leedpulse-monorepo/enums';
import { Dayjs } from 'dayjs';

interface TerminateSubscriptionPopconfirmProps {
  formContext: {
    terminationDate: Dayjs | null;
    onTerminationDateChange: (date: Dayjs | null) => void;
    terminateSubscription: () => void;
    updateStatus: ContextStatus;
  };
  disabled: boolean;
  isLoading: boolean;
  isLeedflow: boolean;
}

const TerminateSubscriptionPopconfirm: React.FC<TerminateSubscriptionPopconfirmProps> = ({
  formContext,
  disabled,
  isLoading,
  isLeedflow,
}) => {
  return (
    <Popconfirm
      title={
        <>
          {!isLeedflow && (
            <div style={{ marginBottom: '16px' }}>
              <span>Date de fin d'abonnement:</span>
              <DatePicker
                placeholder='JJ/MM/AAAA'
                style={{ width: '100%', marginTop: '8px' }}
                format={'DD/MM/YYYY'}
                onChange={(date) => formContext.onTerminationDateChange(date)}
                value={formContext.terminationDate}
              />
            </div>
          )}
          <Alert
            message="Attention"
            description={
              isLeedflow ? (
                <>
                  <strong>Immédiatement:</strong>
                  <ul style={{ paddingLeft: '20px', marginTop: '8px' }}>
                    <li>Le renouvellement Stripe est arrêté, plus aucun prélèvement</li>
                    <li>L'abonnement passe en cours de résiliation</li>
                    <li>La date de fin d'abonnement est alignée sur la fin de la période de facturation déjà payée</li>
                  </ul>
                  <strong>Jusqu'à cette date, rien ne change:</strong>
                  <ul style={{ paddingLeft: '20px', marginTop: '8px' }}>
                    <li>Le numéro reste actif et joignable</li>
                    <li>L'utilisateur assigné garde son accès</li>
                  </ul>
                  <strong>À cette date, automatiquement:</strong>
                  <ul style={{ paddingLeft: '20px', marginTop: '8px' }}>
                    <li>Le numéro est libéré</li>
                    <li>L'utilisateur assigné perd son accès</li>
                    <li>L'abonnement est détaché de la société et mis hors service</li>
                  </ul>
                  Aucun remboursement de la période en cours. L'historique des appels et les transcriptions ne sont pas supprimés.
                </>
              ) : (
                <>
                  En résiliant cet abonnement le ou les actions suivantes vont êtres faites:
                  <ul style={{ paddingLeft: '20px', marginTop: '8px' }}>
                    <li>La date de fin d'abonnement sera actualisée</li>
                    <li>Le nombre de crédits disponibles seront remis à 0</li>
                    <li>Les numéros d'envoyeur seront supprimés de ce client</li>
                    <li>L'intelligence artificielle sera mise en pause</li>
                  </ul>
                </>
              )
            }
            type="warning"
            showIcon
          />
        </>
      }
      onConfirm={(event) => {
        if (event) {
          event.stopPropagation();
        }
        if (isLeedflow || formContext.terminationDate) {
          formContext.terminateSubscription();
        } else {
          message.error('Veuillez sélectionner une date de fin d\'abonnement');
        }
      }}
      onCancel={(event) => {
        if (event) {
          event.stopPropagation();
        }
      }}
      okText="Résilier l'abonnement du client"
      cancelText="Annuler"
      okButtonProps={{ danger: true }}
      icon={null}
    >
      <Button
        type="default"
        danger
        icon={<CloseCircleFilled />}
        style={{ marginRight: "1rem" }}
        loading={isLoading}
        disabled={disabled}
      >
        <span className="extra-label">Résilier</span>
      </Button>
    </Popconfirm>
  );
};

export default TerminateSubscriptionPopconfirm;
